import { render } from "./Interpellation.vue?vue&type=template&id=a4570b44&scoped=true"
import script from "./Interpellation.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Interpellation.vue?vue&type=script&charset=utf-8&lang=js"

import "./Interpellation.vue?vue&type=style&index=0&id=a4570b44&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4570b44"]])

export default __exports__